import autoText from 'ui/autotext/custom.js';
import AbstractSelect from './abstract.js';
import config from './../../config.js';

export default class CitySelect extends AbstractSelect {
    init(elements = {}) {
        super.init(elements);

        this.at = autoText.init(
            this.element,
            {
                type: 'custom',
                values: config.citys,
                requireData: true,
            },
            {
                onselect: ::this._onSelect,
                emptyselect: ::this._onDropSelect,
                ondrop: ::this._onDropSelect,
                open: ::this._onOpen,
            }
        );

        if (!this.at) {
            throw new Error('City autotext init error');
        }

        this.element.on('keyup change', () => {
            this.error = false;
        });

        console.log('City select init complete.');
    }

    select(city) {
        if (!city) {
            return;
        }

        this.at.data(city);
        this._onSelect(this.at, city);
    }
}
